<ng-container *ngIf="overlay$ | async as overlay">
    <ng-container *ngIf="overlay?.template != null">
        <ng-container *ngTemplateOutlet="overlay.template; context:overlay.context"></ng-container>
    </ng-container>
    <ng-container *ngIf="overlay?.component != null">
        <ng-container *ngComponentOutlet="overlay.component; injector:overlayInjector"></ng-container>
    </ng-container>
    <ng-container *ngIf="overlay?.lazyTemplate != null">
        <ng-container *lazyLoad="overlay.lazyTemplate"></ng-container>
    </ng-container>
</ng-container>
